import React from 'react'
import * as f from '../../../components/BPMTable/BPMInputs'
import {
    TableFieldDescription,
    DataMapper,
    DataTransformer,
    NullClickStrategy,
    OnlyFilterActionDisplayStrategy,
    DateTimeComponentCreator,
    DateTimeDisplayCreator,
} from '../../../components/BPMTable/TableMapperCreator'
import { GraphQLDownloadFile } from '../../../components/FileDownloader/FileComponentDownloader'
import { DirectTableQueryBuilder } from '../../../components/BPMTable/TableQueryBuilder/DirectTableQueryBuilder'
import { ExportFooterItemCreator } from '../../../components/BPMTable/TableFooterItems'
import TableCreatorCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreator'
import tableCreatorCreatorFactoryCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'

const queries = { tableQueryBuilder: new DirectTableQueryBuilder('allCompanyChanges') }

class CMCompanyChangeFilesTableCreator extends TableCreatorCreator {
    constructor(filters) {
        super(filters)
    }

    static getId = () => {
        return 'CMCompanyChangeFilesTableCreator'
    }

    getTableCreator = (tableName) => {
        const tableCreator = this.createTableCreator(
            this.constructor.getId(),
            tableName,
            queries,
            new NullClickStrategy(),
            new OnlyFilterActionDisplayStrategy()
        )

        tableCreator.setAdditionalFilters({ first: 30 })
        tableCreator.setInitialSortField('submittedAt', 'desc')
        tableCreator.setTableFooterItems([new ExportFooterItemCreator()])

        tableCreator.addDescriptions([
            new TableFieldDescription(
                'id',
                new DataMapper('id'),
                new f.FilterDescription(new f.NullCreator()),
                { label: 'ID', hideSort: true }
            ),
            new TableFieldDescription(
                'submittedAt',
                new DataMapper('submittedAt'),
                new f.FilterDescription(new f.PeriodFilter('submittedAt')),
                { label: 'Submitted At', componentCreator: new DateTimeComponentCreator(), excelDisplay: new DateTimeDisplayCreator() }
            ),
            new TableFieldDescription(
                'createdAt',
                new DataMapper('createdAt'),
                new f.FilterDescription(new f.PeriodFilter('createdAt')),
                { label: 'Created At', componentCreator: new DateTimeComponentCreator(), excelDisplay: new DateTimeDisplayCreator() }
            ),
            new TableFieldDescription(
                'downloadFile',
                new DataMapper('id', 'file'),
                new f.FilterDescription(new f.NullCreator()),
                {
                    label: 'File',
                    hideSort: true,
                    transform: new DataTransformer(({id, file}) =>
                        file ? <GraphQLDownloadFile resourceType='company_change' id={id} /> : null
                    ),
                }
            ),
        ])

        return tableCreator
    }
}

tableCreatorCreatorFactoryCreator.addTableCreatorCreator(CMCompanyChangeFilesTableCreator)

export default CMCompanyChangeFilesTableCreator
